import React from 'react';
import { WidgetDateTime, WidgetPaymentMethod, WidgetLinkTruncatedText, WidgetLevelLinkText } from '../../../../components';
import { WidgetPrice } from '../../../../components/widget/WidgetPrice';
// import statuses from '../../../../constants/paymentLinks/statuses';
import { useTranslation } from 'react-i18next';
import { palette } from '../../../../styles/theme';

export default function PaymentMovementsColumns ({ handleClickMenuPayment }) {
    const { t } = useTranslation();

    return [{
        dataField: 'id',
        text: t('paymentMovements.table.columns.id'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'order_id',
        text: t('paymentMovements.table.columns.idLink'),
        sort: false,
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => (<WidgetLinkTruncatedText to={`/products/paymentLinks/${row.order_id}`} text={cellContent || ''} styles={{ color: palette.secondary[600] }} truncated ='false'/>),
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'external_id',
        text: t('paymentMovements.table.columns.idPuntored'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'document',
        text: t('paymentMovements.table.columns.dni'),
        sort: false,
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => (<WidgetLevelLinkText levelId={row.id_level} to={`/clients/details/${row.id_user}`} text={cellContent || ''} styles={{ color: palette.primary }} truncated ='false'/>),
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'metadata.transaction_data.transaction_type',
        text: t('paymentMovements.table.columns.paymentMethod'),
        sort: false,
        formatter: (cellContent) => {
            return (
                <WidgetPaymentMethod text={`paymentMovements.table.paymentMethod.${cellContent}`} />
            );
        },
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'amount',
        text: t('paymentMovements.table.columns.amount'),
        sort: false,
        formatter: cellContent => (<WidgetPrice number={cellContent} textAlign='left' width='80px' />),
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'installments',
        text: t('paymentMovements.table.columns.installments'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'created_at',
        text: t('paymentMovements.table.columns.createdAt'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        formatter: (cellContent, row) => {
            const date = row.updated_at ? new Date(row.updated_at) : new Date(row.created_at);
            return (<WidgetDateTime date={date}/>);
        },
    }, {
        dataField: 'status',
        text: t('paymentMovements.table.columns.status'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    }];
}
